import React, { useEffect } from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { PrimaryButton } from "../../Button";

const Row = styled.div`
  display: flex;
`;

const Print = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem;
`;

const Column = styled.div`
  flex: 50%;
  padding: 10px;
`;

const H2 = styled.h2`
  margin-bottom: 5px;
`;

const Ul = styled.ul`
  padding-left: 0px;
  list-style: none;
  line-height: normal;
`;

const PrintBtn = styled(PrimaryButton)`
  width: 10%;
`;

const OrderInfo = (props) => {
  const {
    customerDetails,
    orderId,
    requestedPaymentMethod,
    status,
    type,
    datePlaced,
    numCards,
    cardsValue,
    totalFaceValue,
    print,
  } = props;

  useEffect(() => {
    let dataLayer = window.dataLayer || [];

    dataLayer.push({
      event: "sell-conversion",
      sellOrderNumber: orderId,
      sellType: requestedPaymentMethod,
    });
  }, []);

  const formatCurrency = (amount) =>
    new Intl.NumberFormat("en-US", {
      currencySign: "accounting",
      style: "currency",
      currency: "USD",
    }).format(amount);

  const date = new Date(datePlaced);
  const formattedDate =
    date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();

  let orderAddress = customerDetails.street ? customerDetails.street : "";
  orderAddress += customerDetails.street2 ? " " + customerDetails.street2 : "";
  orderAddress += orderAddress.length ? ", " : "";
  orderAddress += customerDetails.city ? customerDetails.city : "";
  orderAddress += customerDetails.city.length ? ", " : ""; // if added a city, then add a new comma
  orderAddress += customerDetails.state ? customerDetails.state : "";
  orderAddress += customerDetails.postcode
    ? " " + customerDetails.postcode
    : "";

  return (
    <>
      <Print>
        <h1>
          Thank you for submitting your{" "}
          {type === "ecode" ? "online" : "mail in"} required order.
        </h1>
        <PrintBtn id="printBtn" onClick={print}>
          Print
        </PrintBtn>
      </Print>

      <Row>
        <Column>
          <H2>Order Number: {orderId}</H2>
          <Ul>
            <li>
              <b>Date: </b> {formattedDate}
            </li>
            <li>
              <b>Total Payout Amount:</b> {formatCurrency(cardsValue)}
            </li>
            <li>
              <b>Total Face Value:</b> {formatCurrency(totalFaceValue)}
            </li>
            <li>
              <b>Total Card Count:</b> {numCards}
            </li>
            <li>
              <b>Submission Type:</b> {type === "ecode" ? "Online" : "Mail-In"}
            </li>
            <li>
              <b>Payout Method:</b> {requestedPaymentMethod}
            </li>
            <li>
              <b>Order Status:</b> {status}
            </li>
          </Ul>
        </Column>
        <Column>
          <H2>Customer Information</H2>
          <Ul>
            <li>
              <b>Name: </b> {customerDetails.name}
            </li>
            <li>
              <b>Address:</b> {orderAddress}
            </li>
            <li>
              <b>Email:</b> {customerDetails.email}
            </li>
            <li>
              <b>Phone:</b> {customerDetails.phone}
            </li>
          </Ul>
        </Column>
      </Row>
    </>
  );
};

OrderInfo.prototype = {
  customerDetails: PropTypes.object.isRequired,
  orderId: PropTypes.number.isRequired,
  requestedPaymentMethod: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  datePlaced: PropTypes.string.isRequired,
  numCards: PropTypes.number.isRequired,
  cardsValue: PropTypes.number.isRequired,
  totalFaceValue: PropTypes.number.isRequired,
};

export { OrderInfo };
